import { render, staticRenderFns } from "./component-d741a204.vue?vue&type=template&id=5e38bfc3&scoped=true&"
import script from "./component-d741a204.vue?vue&type=script&lang=js&"
export * from "./component-d741a204.vue?vue&type=script&lang=js&"
import style0 from "./component-d741a204.vue?vue&type=style&index=0&id=5e38bfc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e38bfc3",
  null
  
)

export default component.exports